// TODO: Move these properly to tokens at some point
export const componentZIndices = {
  bottomSheet: 100,
  bottomNav: 100, // should be behind drawer since sidenav opens in drawer in mobile
  modal: 1000,
  drawer: 1001,
  dropdownOverlay: 1002,
  tourMask: 1100,
  popover: 1100,
  tooltip: 1100,
  topnav: 100,
};
